import React, { useState, Component, useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import {
  TreeDataState,
  CustomTreeData,
  SearchState,
  IntegratedFiltering,
  SortingState,
  IntegratedSorting,
  FilteringState,
  RowDetailState
} from '@devexpress/dx-react-grid';
import {
  Grid,
  Table,
  TableHeaderRow,
  TableTreeColumn,
  TableColumnVisibility,
  Toolbar,
  ColumnChooser,
  SearchPanel,
  VirtualTable,
  TableFilterRow,
  TableRowDetail
} from '@devexpress/dx-react-grid-material-ui';
import axios from 'axios';
import _ from 'lodash';
import { Tree } from "antd";
import 'antd/dist/antd.css';
//import { Table as antTable } from 'antd';
import Tableant from 'antd/es/table';
import { connect } from 'react-redux';
import moment from 'moment';
import pluralize from 'pluralize';
import { CSVLink, CSVDownload } from "react-csv";
//const { Table as antTable} = antd;
// import {
//     Grid,
//     Table,
//     TableColumnVisibility,
//     Toolbar,
//     ColumnChooser,
//     SearchPanel,
//   } from '@devexpress/dx-react-grid-bootstrap4';

import {
  generateRows,
  defaultColumnValues,
} from '../demo-data';

import RefreshIcon from '@material-ui/icons/Refresh';
import Icon from '@material-ui/core/Icon';
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import metaData from "../metaData";
import metaData2 from "../metaData";
import loader from "../images/loader.gif"
//import Anttree from "./antdTree";
let addDates = metaData[0].addDates;

const TreeNode = Tree.TreeNode;

let _ulbtreeParams = localStorage.getItem("ulbTreeParams");
if(_ulbtreeParams){
  _ulbtreeParams = JSON.parse(_ulbtreeParams);
}
// let tableFilterParams = metaData[0].ulb_treeDtata.params;
let tableFilterParams = _ulbtreeParams;
 let treeFilterParams = metaData2[0].ulb_treeDtata.params;
// let treeFilterParams=ulbtreeParams

let allApis = localStorage.getItem("allApis");
if(allApis){
allApis = JSON.parse(allApis);
}

function formDates(query) {
  var formatStr = 'YYYY-MM-DD';
  var today = moment().subtract(1, 'days').format(formatStr);
  switch (query) {
      case 'today':
          query.fromDate = today;
          query.timeKey = 'today';
          break;
      case 'yesterday':
          query.fromDate = moment().subtract(2, 'days').format(formatStr);
          query.toDate = today;
          query.timeKey = 'today';
          break;
      case 'this_week':
          query.fromDate = moment().startOf('week').format(formatStr);
          query.toDate = moment().format(formatStr);
          query.timeKey = 'today';
          break;
      case 'last_week':
          query.fromDate = moment().startOf('week').subtract(7, 'days').format(formatStr);
          query.toDate = moment().startOf('week').subtract(1, 'days').format(formatStr);
          query.timeKey = 'today';
          break;
      case 'last_7':
          query.fromDate = moment().subtract(7, 'days').format(formatStr);
          query.toDate = moment().subtract(1, 'days').format(formatStr);
          query.timeKey = 'today';
          break;
      case 'last_14':
          query.fromDate = moment().subtract(14, 'days').format(formatStr);
          query.toDate = moment().subtract(1, 'days').format(formatStr);
          query.timeKey = 'today';
          break;
      case 'this_month':
          query.fromDate = moment().startOf('month').format(formatStr);
          query.timeKey = 'month';
          break;
      case 'last_month':
          query.fromDate = moment().subtract(1, 'months').startOf('month').format(formatStr);
          query.toDate = moment().subtract(1, 'months').endOf('month').format(formatStr);
          query.timeKey = 'month';
          break;
      case 'lifetime':
          query.fromDate = "";
          query.toDate = "";
          query.timeKey = 'lifetime';
          break;
      default:
          query.fromDate = today;
          query.timeKey = 'today';
  }
}


let data = [{
  name: "AP",
  buildings: "0",
  dwellings: "0",
  spaceKey: "AP",
  items: []
}]

let tabParams= {};

const ROOT_ID = '';
var ulbState;
let firstLayerUlbArray = [{
  dDN_Count: "Loading...",
  state: "Venu",

}];

let paarams = localStorage.getItem("ulbTreeParams");
if(paarams){
  paarams = JSON.parse(paarams);
}


let presentwork_order = localStorage.getItem("workOrderObj");
    let hierarchy;
    if(presentwork_order){
      presentwork_order = JSON.parse(presentwork_order);
    hierarchy=presentwork_order.hierarchy;
    hierarchy.map((ele)=>{
      tabParams[ele]={...paarams};
    })
    }

const getChildRows = (row, rootRows) => (row ? row.items : rootRows);
let originalUlbTableDataObject = [];

// const getChildRows = (row, rootRows) => {
//   const childRows = rootRows.filter(r => r.parentId === (row ? row.id : ROOT_ID));
//   if (childRows.length) {
//     return childRows;
//   }
//   return row && row.hasItems ? [] : null;
// };

let workOrder;
let treeLevelLength;
let work_order = localStorage.getItem("workOrderObj");
if(work_order){
work_order = JSON.parse(work_order);
workOrder=work_order.workOrder
}
if(workOrder=='ND'){
  treeLevelLength=7
}
// else if(){}

// function removePluMinusLastLayer(obj){
//   if(hierarchyLen<=3){
//     obj.children
//   }
// }
let th;


export class Ulb extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: "",
      selectedProject: metaData[0],
      tableselectedProject:metaData[0],
      treeDataLayer: [],
      expand_all: [],
      loading: true,
      secondLayerLength: 0,
      getWorkorder: "",
      expandArray: [],
      ulbTableDataObject: [{ state: "AP", dDN_Count: 1 }],
      fourthLayerArray: [],
      fifthLayerArray: [],
      thirdLayerArray: [],
      secondLayerArray: [],
      firstLayerArray: [],
      WorkOrderClients: [],
      originalUlbTableDataObject: [],
      originalUlbTableDataObject2: "",
      treeTimeFilter: false,
      parentObj: {},
      treeFilter:true,
      tablesFilter:true,
      clickedFilter:"",
      clickeddownloadData:{},
      alldownloadableData:"",
      ulbHeader: [
        { label: "Name", key: "name" },
        { label: "DDN Count", key: "dDN_Count" },
      ]

    }
    //this.a=this.a.bind(this)
    this.expandAll = this.expandAll.bind(this);
    this.collapseAll = this.collapseAll.bind(this);
    this.treeDataFunction = this.treeDataFunction.bind(this);
    this.clickRow = this.clickRow.bind(this);
    this.callDidMountMultipleTimes=this.callDidMountMultipleTimes.bind(this);
    this.downloadUlbData =this.downloadUlbData.bind(this);
    this.downloadAllData=this.downloadAllData.bind(this);
    th=this;
  }
  //let secondLayerLength=this.state.treeDataLayer.children.length

  clickRow(id) {
    this.setState({
      expand_all: id
    })

    // expandedRows

  }


  treeDataFunction(paramsFromFilters,interval) {

    let _workOrder = localStorage.getItem("workOrderObj");
    _workOrder = JSON.parse(_workOrder);

    if(!interval){
    axios.get(this.state.selectedProject.workOrder.url, {
      params: this.state.selectedProject.workOrder.params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        this.setState({
          getWorkorder: res.data.response.workOrderObj
        })

      })
    }
    let hierarchyLevels;
    let _treeLevel;
    if (_workOrder) {
      hierarchyLevels = _workOrder.hierarchy;
      _treeLevel = _workOrder.treeLevel;
    }

    if (paramsFromFilters) {
      paramsFromFilters = paramsFromFilters;
    } else {
      paramsFromFilters = this.state.selectedProject.ulb_treeDtata.params
    }
    axios.get(this.state.selectedProject.ulb_treeDtata.url, {
      params: paramsFromFilters,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        if (res.data.response.analyticsDocs.length <= 0) {
          this.setState({
            loading: false,
          })
        }
        // else{
        //   this.setState({
        //     loading:true,
        //
        //   })
        // }
////////////////////////////////////////////////////////////////


let response = res.data.response.analyticsDocs;

if(this.state.treeFilter){


        function getCurrency(num) {
          return (num + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        };

        function getParentAtLevel(key, index) {
          if (index === 0) {
            return key.substring(0, key.lastIndexOf('_'));
          }
          var retString = key;
          for (var m = 0; m < index; m++) {
            retString = retString.substring(0, retString.lastIndexOf('_'));
          }
          return retString;
        }

        function getLevel(name) {
          var arr = name.split('_');
          return arr.length;
        }


        let results = getTreeFormat(response);

        let maxHierarchy = hierarchyLevels.length || 4
        let treeLevel = _treeLevel || 1;
        let treeData = [];
        var length = results.length;
        var tempObj = {}, tempAgentObj = {}, maxLevel = maxHierarchy - treeLevel;
        for (var i = 0; i < length; i++) {
          var obj = results[i];
          var name = obj._id.name;
          var displayName = obj._id.displayName;
          if (!tempObj[name]) {
            tempObj[name] = { parcelCount: obj.parcelCount || 0, buildingCount: obj.buildingCount || 0, dwellingCount: obj.dwellingCount || 0 };
          } else {
            tempObj[name].parcelCount += obj.parcelCount;
            tempObj[name].buildingCount += obj.buildingCount;
            tempObj[name].dwellingCount += obj.dwellingCount;
          }
          tempObj[name].displayName = displayName;
        }

        if (!results.length) {
          this.setState({
            treeDataLayer: []
          })
        }
        var keys = Object.keys(tempObj);
        var treeObj = {};
        let count = 1;
        let uniqKey = 0;
        for (i = 0; i < keys.length; i++) {
          let _obj = {};
          var key = keys[i];
          var level = getLevel(key);
          var obj = tempObj[key];
          if (level === 1) {
            treeObj = {
              'name': obj.displayName,
              'rowKey': key,
              'key': i,
              //	'parcelStr': getCurrency(obj.parcelCount),
              'buildings': getCurrency(obj.buildingCount),
              'dwellings': getCurrency(obj.dwellingCount),
              'items': [],
            };
          } else {
            var positionalArr = treeObj.items, j = 2;
            if (positionalArr.length) {
              while (j < level) {

                for (var k = 0; k < positionalArr.length; k++) {
                  if (positionalArr[k].rowKey === getParentAtLevel(key, (level - j))) {
                    positionalArr = positionalArr[k].items;

                    break;
                  }
                }
                j++;
              }
            }

            _obj = {
              'name': obj.displayName,
              'rowKey': key,
              //	'parcelStr': getCurrency(obj.parcelCount),
              'buildings': getCurrency(obj.buildingCount),
              'dwellings': getCurrency(obj.dwellingCount),
              'items': []
            }

            let hierarchy
            if(work_order){
             hierarchy = work_order.hierarchy.length;
            }
            var positionalIndex = positionalArr.length-1;
            if(level === hierarchy) {
              delete _obj.items;
            }



            if (level == 2) {
              _obj.key = count++
            }
            positionalArr.push(_obj);
            var positionalIndex = positionalArr.length - 1;

          }

        }
        if (keys.length) {
          // treeObj.key=uniqKey++
          // removePluMinusLastLayer(treeObj);
          treeData.push(treeObj);
        }

        this.setState({
          treeDataLayer: treeData
        })

      }

        ////////////////////////////////////////


        if(!interval){
        if(this.state.tablesFilter){

        // let hierarchy = this.state.getWorkorder ? this.state.getWorkorder.hierarchy : [];
        let hierarchy;
            if(work_order){
             hierarchy = work_order.hierarchy;
            }
        let ulbDataObj = {};
        let completed = false;

        let arr1 = [];
        let firstArr = [];
        let secondArr = [];
        let thirdArr = [];
        let fourthArr = [];
        let fifthArr = [];
        response.map(ele => {
          if (ele.zp_type == 7) {
            if (ele.space.key == hierarchy[0]) {
              firstArr.push({ name: ele.space.name, dDN_Count: ele.count.ddn, spaceKey: ele.space.key, spaceValue: ele.space.value, parent_key: ele.space.parent ? ele.space.parent.value : "" });
            } else if (hierarchy[1] && ele.space.key == hierarchy[1]) {
              secondArr.push({ name: ele.space.name, dDN_Count: ele.count.ddn, spaceKey: ele.space.key, spaceValue: ele.space.value, parent_key: ele.space.parent ? ele.space.parent.value : "" });
            } else if (hierarchy[2] && ele.space.key == hierarchy[2]) {
              thirdArr.push({ name: ele.space.name, dDN_Count: ele.count.ddn, spaceKey: ele.space.key, spaceValue: ele.space.value, parent_key: ele.space.parent ? ele.space.parent.value : "" });
            } else if (hierarchy[3] && ele.space.key == hierarchy[3]) {
              fourthArr.push({ name: ele.space.name, dDN_Count: ele.count.ddn, spaceKey: ele.space.key, spaceValue: ele.space.value, parent_key: ele.space.parent ? ele.space.parent.value : "" });
            } else if (hierarchy[4] && ele.space.key == hierarchy[4]) {
              fifthArr.push({ name: ele.space.name, dDN_Count: ele.count.ddn, spaceKey: ele.space.key, spaceValue: ele.space.value, parent_key: ele.space.parent ? ele.space.parent.value : "" });
            }
          }
        })
        let layer1 = hierarchy[0];
        let ulbObj = {};
        if(secondArr[0]){
        secondArr[0].parent = firstArr;
      }
      if(thirdArr[0]){
        thirdArr[0].parent = secondArr;
    }
        if (fourthArr[0]) {
          fourthArr[0].parent = thirdArr;
        }
        if (fifthArr[0]) {
          fifthArr[0].parent = fourthArr;
        }

        let parentObj = {};
        parentObj[hierarchy[1]] = firstArr;
        parentObj[hierarchy[2]] = secondArr;
        if (hierarchy[3]) {
          parentObj[hierarchy[3]] = thirdArr;
        }
        if (hierarchy[4]) {
          parentObj[hierarchy[4]] = fourthArr;
        }

        ulbObj[hierarchy[0]] = firstArr;
        ulbObj[hierarchy[1]] = secondArr;
        ulbObj[hierarchy[2]] = thirdArr;
        if (hierarchy[3]) {
          ulbObj[hierarchy[3]] = fourthArr;
        }
        if (hierarchy[4]) {
          ulbObj[hierarchy[4]] = fifthArr;
        }
        localStorage.setItem("ulbTableDataObject", JSON.stringify(ulbObj));

        this.setState({
          originalUlbTableDataObject: ulbObj,
          parentObj: parentObj
        })


      }


    }

        //ppppppppppppppppppppp


        let cityCount = 1;


        function getParent(tree_id) {
          var tempTreeIds = tree_id.split('_');
          var tempTreeID = '';
          for (var i = 0; i < tempTreeIds.length - 1; i++) {
            if (i != 0) {
              tempTreeID = tempTreeID + '_' + tempTreeIds[i];
            }
            else {
              tempTreeID = tempTreeID + tempTreeIds[i];
            }
          }
          return tempTreeID;
        }

        function getTreeFormat(data) {
          var tempResults = [];
          for (var i = 0; i < data.length; i++) {
            if (data[i].zp_type === 7) {
              tempResults.push({ 'buildingCount': data[i].count.ddn, 'dwellingCount': 0, parcelCount: 0, '_id': { 'name': data[i].treeId, 'parent': getParent(data[i].treeId), 'displayName': data[i].space.name } })
            }
            else if (data[i].zp_type === 8) {
              tempResults.push({ 'buildingCount': 0, 'dwellingCount': data[i].count.ddn, parcelCount: 0, '_id': { 'name': data[i].treeId, 'parent': getParent(data[i].treeId), 'displayName': data[i].space.name } })
            }
          }
          return tempResults;
        }


      }).catch(err => console.log(err, "error in ulbtreee"))


  }

  componentWillUnmount() {

    let ulbtreeParams = localStorage.getItem("ulbTreeParams");
    if(ulbtreeParams){
      ulbtreeParams = JSON.parse(ulbtreeParams);
    }


    tableFilterParams = ulbtreeParams;
    treeFilterParams = ulbtreeParams;


    let selectedProj=this.state.selectedProject;
    selectedProj.ulb_treeDtata.params=ulbtreeParams;
    selectedProj.ulb_treeDtata.params.userKey='allClients';
    selectedProj.ulb_treeDtata.params.clientId="";
    selectedProj.ulb_treeDtata.params.spaceKey="";
    selectedProj.ulb_treeDtata.params.parentKey="";
    selectedProj.ulb_treeDtata.params.parentValue="";
    selectedProj.ulb_treeDtata.params.timeKey='lifetime'
   //  let ulb_treeDtata=
   //  this.state.selectedProject.ulb_treeDtata.params=ulbtreeParams;
    this.setState({
     selectedProject:selectedProj
    })

    // clearInterval(this.timer);
    // this.timer = null;

  }

  componentDidMount() {
    // let work_order = localStorage.getItem("workOrderObj");
    // let hierarchy;
    // if(work_order){
    // work_order = JSON.parse(work_order);
    // hierarchy=work_order.hierarchy;
    // hierarchy.map((ele)=>{
    //   tabParams[ele]={...paarams};
    // })
    // }

   

//     tableFilterParams = ulbtreeParams;
//  treeFilterParams = ulbtreeParams;
//  let selectedProj=this.state.selectedProject;
//  selectedProj.ulb_treeDtata.params=ulbtreeParams;
// //  let ulb_treeDtata=
// //  this.state.selectedProject.ulb_treeDtata.params=ulbtreeParams;
//  this.setState({
//   selectedProject:selectedProj
//  })


    // var input = document.getElementsByClassName("TableTreeExpandButtonBase-hidden-89");
    this.treeDataFunction();



    axios.get(this.state.selectedProject.workOrderClients.url, {
      params: this.state.selectedProject.workOrderClients.params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        let workOrderClientsData = res.data.response.clientObjs;
        let clientObjectAyyay = [];
        workOrderClientsData.map((client) => {
          let clientObject = {
            name: client.app_name,
            id: client._id
          }
          clientObjectAyyay.push(clientObject);
        })
        this.setState({
          WorkOrderClients: clientObjectAyyay
        })

      })

    let ulb_treeDtataParams = this.state.selectedProject.ulb_treeDtata.params

    // this.timer = setInterval(() => {
    //   th.callDidMountMultipleTimes();
    // }, 10000)


  }

  callDidMountMultipleTimes(){
    this.treeDataFunction("",true);
    // tableAreaFilter
  }

  expandAll(e) {
    let rows = [];
    if (this.state.treeDataLayer[0]) {
      let allrows = [];
      for (let i = 0; i <= this.state.treeDataLayer[0].items.length; i++) {
        allrows.push(i)
      }
      if (allrows.length > 6) {
        rows = allrows
      } else {
        rows = [0, 1, 2, 3, 4, 5, 6]
      }
    }
    this.setState({
      expand_all: rows
      // expand_all:true
    })
  }
  collapseAll(e) {
    this.setState({
      expand_all: []
    })
  }

  // tableTimeFilterChange(e) {
  //   let id = e.target.id;
  //   tableFilterParams.timeKey = e.target.value;
  //   axios.get(this.state.selectedProject.ulb_treeDtata.url, {
  //     params: tableFilterParams,
  //     headers: this.state.selectedProject.headers
  //   })
  //     .then(res => {
  //       let dtataObject = this.state.originalUlbTableDataObject;
  //       let dataArray = dtataObject[id];
  //       let filteredArray = [];

  //       dataArray.map((ele) => {
  //         res.data.response.analyticsDocs.map((data) => {
  //           if (ele[id] == data.space.name) {
  //             filteredArray.push(ele);
  //           } else {
  //             filteredArray = [];
  //           }
  //         })

  //       })

  //       // this.setState({
  //       //   originalUlbTableDataObject:
  //       // })
  //       let obj = this.state.originalUlbTableDataObject;
  //       // obj[id]=filteredArray;

  //     })
  // }

  tableAgencyChangeFilter(e) {
  }

  tableAreaFilter(e) {









    this.setState({
      clickedFilter:'table'
    })
    let params = "";
    let spaceKey = e.target.id;
    let obj = this.state.originalUlbTableDataObject;
    let _ulbTableDataObj = localStorage.getItem("ulbTableDataObject");
    _ulbTableDataObj = JSON.parse(_ulbTableDataObj);

    // let ulbTableDataObj = localStorage.getItem("ulbTableDataObject");
    // ulbTableDataObj = JSON.parse(ulbTableDataObj);
    // firstLayerUlbArray[0].parent = [];
    //  ulbTableDataObj[spaceKey] = firstLayerUlbArray;
    // this.setState({
    //   originalUlbTableDataObject: ulbTableDataObj
    // })

    let ulbTableDataObj = this.state.originalUlbTableDataObject;
    firstLayerUlbArray[0].parent = [];
    ulbTableDataObj[spaceKey] = firstLayerUlbArray;
   this.setState({
     originalUlbTableDataObject: ulbTableDataObj
   })

    if (e.target.name == "timeFilter" || e.target.name == "agencyFilter") {
      if (e.target.name == "timeFilter") {
        tabParams[spaceKey].timeKey= e.target.value;
        // tableFilterParams.timeKey=tabParams[spaceKey].timeKey;
        //tableFilterParams.timeKey = e.target.value;
        addDates(tabParams[spaceKey]);
       
        // if(tabParams[spaceKey].timeKey=='today'){
          if(e.target.value=='today' || e.target.value=='this_month'){
          // tableFilterParams.toDate=""
          tabParams[spaceKey].toDate="";
        }
        // tableFilterParams.spaceKey = spaceKey;
        // tableFilterParams.parentKey = "";
        // tableFilterParams.parentValue = "";

 // tableFilterParams.spaceKey = spaceKey;
        // tableFilterParams.parentKey = "";
        // tableFilterParams.parentValue = "";
        tabParams[spaceKey].spaceKey = spaceKey;

        // tabParams[spaceKey].parentKey = "";
        // tabParams[spaceKey].parentValue = "";


      }
      if (e.target.name == "agencyFilter") {
        if (e.target.value == 'all') {

          tabParams[spaceKey].userKey='allClients';
          tabParams[spaceKey].clientId="";

          // tableFilterParams.userKey= tabParams[spaceKey].userKey;
          // tableFilterParams.clientId= tabParams[spaceKey].clientId;
          // tableFilterParams.userKey = "allClients";
          // tableFilterParams.clientId = "";
        } else {
          tabParams[spaceKey].userKey= "client";
          tabParams[spaceKey].clientId=  e.target.value;

          // tableFilterParams.userKey= tabParams[spaceKey].userKey;
          // tableFilterParams.clientId= tabParams[spaceKey].clientId

          // tableFilterParams.userKey = "client";
          // tableFilterParams.clientId = e.target.value;
        }

        // tableFilterParams.spaceKey = spaceKey;
        // tableFilterParams.parentKey = "";
        // tableFilterParams.parentValue = "";

        tabParams[spaceKey].spaceKey = spaceKey;
        // tabParams[spaceKey].parentKey = "";
        // tabParams[spaceKey].parentValue = "";
      }
      // ulbTableDataObj = localStorage.getItem("ulbTableDataObject");
      // ulbTableDataObj = JSON.parse(ulbTableDataObj);
    } else {
      if (e.target.value !== "all") {
        let value = JSON.parse(e.target.value);
        let parentKey = value.spaceKey;
        let parentValue = value.spaceValue;
        // params = this.state.selectedProject.ulb_treeDtata.params;
        //params = this.state.tableselectedProject.ulb_treeDtata.params;
        // params.spaceKey = spaceKey;
        // params.parentKey = parentKey;
        // params.parentValue = parentValue;
      
        tabParams[spaceKey].spaceKey = spaceKey;
        tabParams[spaceKey].parentKey = parentKey;
        tabParams[spaceKey].parentValue = parentValue;

      }else{
        if(e.target.value=='all'){
          tabParams[spaceKey].parentKey = "";
          tabParams[spaceKey].parentValue = "";
        }
      }
      // if(e.target.value=='lifetime'){
      //   params.timeKey='lifetime'
      // }else{
      //   params.timeKey=e.target.value
      // }



      if (e.target.value == "all") {
        // params = this.state.selectedProject.ulb_treeDtata.params;

        // params = this.state.tableselectedProject.ulb_treeDtata.params;
        // params.spaceKey = spaceKey;
        // params.parentKey = "";
        // params.parentValue = "";

        tabParams[spaceKey].spaceKey = spaceKey;
        tabParams[spaceKey].parentKey = "";
        tabParams[spaceKey].parentValue = "";
      }

      if (e.target.name == "timeFilter") {
        // params.timeKey = e.target.value
        // params.timeKey = tabParams[spaceKey].timeKey
        tabParams[spaceKey].timeKey=tabParams[spaceKey].timeKey;
      }

      tableFilterParams = params

      // ulbTableDataObj = localStorage.getItem("ulbTableDataObject");
      // ulbTableDataObj = JSON.parse(ulbTableDataObj);

    }









    axios.get(this.state.selectedProject.ulb_treeDtata.url, {
      // params: tableFilterParams,
      params:tabParams[spaceKey],
      headers: this.state.selectedProject.headers
    })
      .then(res => {
        let response = res.data.response.analyticsDocs;
        let filteredArray = [];
        response.map((data) => {

          if(data.zp_type==7){
          let spaceVal = data.space.value;
          // if(spaceVal){
          //   spaceVal.toString().trim()
          // }
          // let obj = {};
          _ulbTableDataObj[spaceKey].map((element) => {
            let spaceValue = element.spaceValue;
            //  if(spaceValue){
            //   spaceValue.toString().trim()
            //  }
            let obj = {};
            obj.name = data.space.name;
            obj.dDN_Count = data.count.ddn;
            obj.spaceKey = spaceKey;
            obj.spaceValue = data.space.value;
            obj.parent_key = data.space.parent.value;
            obj._id = data._id;

            if (data.space.parent.value == element.parent_key) {
              filteredArray.push(obj);
            }
          })
        }
        })

        filteredArray = _.uniqBy(filteredArray, "_id");

        var holder = {};
        filteredArray.forEach(function(d) {
          if (holder.hasOwnProperty(d.name)) {
            holder[d.name] = holder[d.name] + d.dDN_Count;
          } else {
            holder[d.name] = d.dDN_Count;
          }
        });
        var obj2 = [];
        for (var prop in holder) {
          obj2.push({ name: prop, dDN_Count: holder[prop] });
        }

        filteredArray=obj2;

        let dataArray=[];
        // filteredArray.map((ele,index)=>{
        //   let count=0;
        //   filteredArray.map((element)=>{
        //     if(ele.name==element.name){
        //       count= count+element.dDN_Count;
        //     }
        //   });
        //   ele.dDN_Count=count;
        //   dataArray.push(ele);
        //   count=0;
        // })


        // filteredArray = _.uniqBy(filteredArray, "name");
        let prev;
        if (_ulbTableDataObj) {
          prev = _ulbTableDataObj[spaceKey][0].parent;
        }

        // let obj = this.state.originalUlbTableDataObject;
        if (filteredArray.length > 0) {
        }
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (key == spaceKey && filteredArray[0]) {
              filteredArray[0].parent = prev
              obj[key] = filteredArray
            }
            if (res.data.response.analyticsDocs.length == 0) {

              obj[spaceKey] = [];

            }
          }
        }
        this.setState({
          originalUlbTableDataObject: obj
        })

      })




      
  }

  treeTimeFilter(e) {
    this.setState({
      loading: true,
      clickedFilter:'tree'
    })
    treeFilterParams.timeKey = e.target.value;
    this.setState({
      treeTimeFilter: true,
      tablesFilter:false
    })
    addDates(treeFilterParams);
    if(e.target.value=='today' || e.target.value=='this_month'){
      treeFilterParams.toDate='';
    }
    let clickedFilter='tree';
    this.treeDataFunction(treeFilterParams);
  }

  treeAgencyFilter(e) {
    this.setState({
      loading: true,
      treeDataLayer: [],
      tablesFilter:false,
      clickedFilter:'tree'
    });
    if (e.target.value == 'all') {
      treeFilterParams.userKey = "allClients";
      treeFilterParams.clientId = ""
    } else {
      treeFilterParams.userKey = "client";
      treeFilterParams.clientId = e.target.value;
    }

    this.setState({
      treeTimeFilter: true,
    })
    let clickedFilter='tree';
    this.treeDataFunction(treeFilterParams);
  }

  downloadUlbData(e){
let value=e.target.id;
this.downloadAllData(value);

let clickeddownloadData=this.state.clickeddownloadData;
if(!clickeddownloadData[value]){
  clickeddownloadData[value]=false
}

  clickeddownloadData[value]=!clickeddownloadData[value];

console.log(clickeddownloadData,"clickeddownloadDatad");
// clickeddownloadData[value]=!clickeddownloadData[value] 
this.setState({
  clickeddownloadData:{...clickeddownloadData}
})
  }

  downloadAllData(value){   
   
    axios.get(this.state.selectedProject.ulb_treeDtata.url, {
      params: allApis.ulb_treeDtata.params ? allApis.ulb_treeDtata.params : this.state.selectedProject.ulb_treeDtata.params,
      headers: this.state.selectedProject.headers
    })
      .then(res => {
       if(res.data.response){
let response = res.data.response.analyticsDocs;
console.log(response,"iiidddddd");


let hierarchy;
if(work_order){
 hierarchy = work_order.hierarchy;
}
let firstArr = [];
let secondArr = [];
let thirdArr = [];
let fourthArr = [];
let fifthArr = [];
response.map(ele => {
if (ele.zp_type == 7) {
if (ele.space.key == hierarchy[0]) {
  firstArr.push({ name: ele.space.name, dDN_Count: ele.count.ddn, spaceKey: ele.space.key, spaceValue: ele.space.value, parent_key: ele.space.parent ? ele.space.parent.value : "" });
} else if (hierarchy[1] && ele.space.key == hierarchy[1]) {
  secondArr.push({ name: ele.space.name, dDN_Count: ele.count.ddn, spaceKey: ele.space.key, spaceValue: ele.space.value, parent_key: ele.space.parent ? ele.space.parent.value : "" });
} else if (hierarchy[2] && ele.space.key == hierarchy[2]) {
  thirdArr.push({ name: ele.space.name, dDN_Count: ele.count.ddn, spaceKey: ele.space.key, spaceValue: ele.space.value, parent_key: ele.space.parent ? ele.space.parent.value : "" });
} else if (hierarchy[3] && ele.space.key == hierarchy[3]) {
  fourthArr.push({ name: ele.space.name, dDN_Count: ele.count.ddn, spaceKey: ele.space.key, spaceValue: ele.space.value, parent_key: ele.space.parent ? ele.space.parent.value : "" });
} else if (hierarchy[4] && ele.space.key == hierarchy[4]) {
  fifthArr.push({ name: ele.space.name, dDN_Count: ele.count.ddn, spaceKey: ele.space.key, spaceValue: ele.space.value, parent_key: ele.space.parent ? ele.space.parent.value : "" });
}
}
})
let layer1 = hierarchy[0];
let ulbObj = {};
if(secondArr[0]){
secondArr[0].parent = firstArr;
}
if(thirdArr[0]){
thirdArr[0].parent = secondArr;
}
if (fourthArr[0]) {
fourthArr[0].parent = thirdArr;
}
if (fifthArr[0]) {
fifthArr[0].parent = fourthArr;
}

let parentObj = {};
parentObj[hierarchy[1]] = firstArr;
parentObj[hierarchy[2]] = secondArr;
if (hierarchy[3]) {
parentObj[hierarchy[3]] = thirdArr;
}
if (hierarchy[4]) {
parentObj[hierarchy[4]] = fourthArr;
}

ulbObj[hierarchy[0]] = firstArr;
ulbObj[hierarchy[1]] = secondArr;
ulbObj[hierarchy[2]] = thirdArr;
if (hierarchy[3]) {
ulbObj[hierarchy[3]] = fourthArr;
}
if (hierarchy[4]) {
ulbObj[hierarchy[4]] = fifthArr;
}
console.log(ulbObj[value],"ulbObjulbObj");
let downloadableData=ulbObj;
this.setState({
alldownloadableData: downloadableData,
})

}
})

  }

  toggleExpandDownload(e){
let value=e.target.id;
let clickeddownloadData=this.state.clickeddownloadData;

  clickeddownloadData[value]=!clickeddownloadData[value];
this.setState({
  clickeddownloadData:{...clickeddownloadData}
})


  }



  render() {
    console.log(this.state.alldownloadableData,"this.state.alldownloadableData++")
    const columns = [
      { name: 'name', title: 'Name' },
      { name: 'gender', title: 'Gender' },
      { name: 'city', title: 'City' },
      { name: 'car', title: 'Car' },
    ];

    let dummyRow = [{
      name: 'ND', rowKey: "ND", key: 0, buildings: "100", dwellings: "101",
      childre: [{
        name: 'ND', rowKey: "ND", key: 0, buildings: "100", dwellings: "101",
        childre: []
      }]
    }]

    const antcolumns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Buildings',
        dataIndex: 'buildings',
        key: 'buildings',
        // width: '12%',
      },
      {
        title: 'Dwellings',
        dataIndex: 'dwellings',
        // width: '30%',
        key: 'dwellings',
      },

    ];

    const data = generateRows({
      columnValues: {
        ...defaultColumnValues,
        items: ({ random }) => (random() > 0.5
          ? generateRows({
            columnValues: {
              ...defaultColumnValues,
              items: () => (random() > 0.5
                ? generateRows({
                  columnValues: {
                    ...defaultColumnValues,
                  },
                  length: Math.trunc(random() * 5) + 1,
                  random,
                })
                : null),
            },
            length: Math.trunc(random() * 3) + 1,
            random,
          })
          : null),
      },
      length: 3,
    });

    let tableColumnExtensions = [
      { columnName: 'name', width: 300, height: 300 },
    ];


    let data2 = [{
      gender: "Female",
      name: "Sandra",
      city: "Las Vegas",
      car: "Audi A4",
      items: null
    }, {
      gender: "Male",
      name: "Venu",
      city: "Amarica",
      car: "Swift",
      items: null
    }, {
      gender: "Female",
      name: "Sandra",
      city: "Las Vegas",
      car: "Audi A4",
      items: null
    }, {
      gender: "Male",
      name: "Venu",
      city: "Amarica",
      car: "Swift",
      items: null
    }, {
      gender: "Female",
      name: "Sandra",
      city: "Las Vegas",
      car: "Audi A4",
      items: null
    }, {
      gender: "Male",
      name: "Venu",
      city: "Amarica",
      car: "Swift",
      items: null
    }, {
      gender: "Female",
      name: "Sandra",
      city: "Las Vegas",
      car: "Audi A4",
      items: null
    }, {
      gender: "Male",
      name: "Venu",
      city: "Amarica",
      car: "Swift",
      items: null
    }, {
      gender: "Male",
      name: "Sandra",
      city: "Las Vegas",
      car: "Audi A4",
      items: null
    }, {
      gender: "Male",
      name: "Venu",
      city: "Amarica",
      car: "Swift",
      items: null
    }, {
      gender: "Female",
      name: "Sandra",
      city: "Las Vegas",
      car: "Audi A4",
      items: null
    }, {
      gender: "Male",
      name: "Venu",
      city: "Amarica",
      car: "Swift",
      items: null
    }]
    //let columns2=[];
    //  if(this.state.getWorkorder ) {
    //   this.state.getWorkorder.hierarchy.map((ele)=>{
    //     columns2.push({
    //       name:ele,
    //       title:ele
    //     })
    //   })
    //  }

    let columns2 = [
      {
        name: 'name',
        title: 'Name'
      },
      {
        name: 'dDN_Count',
        title: 'DDN Count'
      }];
    let tableColumnObject = {};
    let hierarche = this.state.getWorkorder ? this.state.getWorkorder.hierarchy : [0]
    for (let i = 0; i < hierarche.length; i++) {
      let val = hierarche[i]
      tableColumnObject[val] = [{
        name: hierarche[i],
        title: hierarche[i]
      }, {
        name: 'dDN_Count',
        title: 'DDN Count'
      }
      ]
    }



    // let columns2 = [{ name: "name", title: "Name" },
    // { name: "gender", title: "Gender" },
    // { name: "city", title: "City" },
    // { name: "car", title: "Car" }]




    let getHiddenColumnsFilteringExtensions = hiddenColumnNames => hiddenColumnNames
      .map(columnName => ({
        columnName,
        predicate: () => false,
      }));
    let defaultHiddenColumnNames = [];
    let filteringColumnExtensions = getHiddenColumnsFilteringExtensions(defaultHiddenColumnNames);
    let setFilteringColumnExtensions = getHiddenColumnsFilteringExtensions(defaultHiddenColumnNames);
    let onHiddenColumnNamesChange = hiddenColumnNames =>
      getHiddenColumnsFilteringExtensions(hiddenColumnNames);



    const treeDtata_columns = [
      { name: 'name', title: 'Name' },
      { name: 'buildings', title: 'Buildings' },
      { name: 'dwellings', title: 'Dwellings' },
    ];
    let setExpandenRowIds = [0, 1]
    let expandedRowIds = []; let setExpandedRowIds = [];

    let getRowId = row => row.id;

    // const loadData = () => {
    //   const rowIdsWithNotLoadedChilds = [ROOT_ID, ...expandedRowIds]
    //     .filter(rowId => data.findIndex(row => row.parentId === rowId) === -1);
    //   if (rowIdsWithNotLoadedChilds.length) {
    //     if (this.state.loading) return;




    //   }
    // };
    //     loadData();



    let getTreeRowLevel = 1

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
      },
      onSelect: (record, selected, selectedRows) => {
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
      },
    };
    ulbState = this.state

    if (this.state.ulbTableDataObject.locality) {
    }
    if (this.state.getWorkorder.hierarchy) {
    }

    return (

      <div>




        <div className='container-fluid tree-card'>
          <div className="card">
            {/* <Paper > */}
            <div className='col-md-12 top-of-head'></div>
            <div className='col-md-12' id='heading'>AGENT REPORT</div>
            <br />
            <div className='row' id='select-row'>
              <div className='col-md-3 firsr-select' >
                <select class="form-control" id="sel1" onChange={this.treeAgencyFilter.bind(this)}>
                  <option value="all">All Agencies</option>
                  {this.state.WorkOrderClients ? this.state.WorkOrderClients.map((client) => {
                    return <option value={client.id}>{client.name}</option>
                  })
                    : ""}
                </select>
              </div>
              <div className='col-md-3'>
                <select class="form-control" id="sel1" onChange={this.treeTimeFilter.bind(this)}>
                  <option value='lifetime'>Life Time</option>
                  <option value='today'>Today</option>
                  <option value='yesterday'>Yesterday</option>
                  <option value='last_7'>Last 7Days</option>
                  <option value='last_14'>last_14</option>
                  <option value='this_month'>This Month</option>
                  <option value='last_month'>Last Month</option>
                  <option value='this_year'>This Year</option>

                </select>
              </div>
              <div className='col-md-3'></div>
              <div className='col-md-3'>
                <button className='btn btn-default btn-sm' onClick={this.expandAll} id='expand-button'>Expand All</button>
                <button className='btn btn-default btn-sm' onClick={this.collapseAll} id='collapse-button'>Collapse All</button>

              </div>
            </div>

            {/* <Anttree data={this.state}/> */}
            {this.state.treeDataLayer.length > 0 ?
              <div className='tree-div'>
                <Paper>
                  <Grid
                    rows={this.state.treeDataLayer}
                    columns={treeDtata_columns}
                  // getRowId={getRowId}
                  // rows={data}
                  // columns={columns}
                  //  expandButtonComponent="true"

                  >
                    <TreeDataState
                      //  expandedRowIds='["0","1","2","3","4","5","6","7","8","9","10"]'
                      expandedRowIds={this.state.expand_all}
                      // getRowId={this.rowchange(expanded, record)}
                      onExpandedRowIdsChange={
                        (expanded, record) => {
                          this.clickRow(expanded, record)
                        }
                      }

                    />
                    <CustomTreeData
                      getChildRows={getChildRows}

                    />
                    <Table
                      columnExtensions={tableColumnExtensions}

                    />
                    <TableHeaderRow
                    />
                    <TableTreeColumn
                      for="name"

                    />

                  </Grid>
                </Paper>
              </div>


              // <Tableant columns={antcolumns}
              //  dataSource={this.state.treeDataLayer} expandedRowKeys={this.state.expand_all} pagination={false}
              //   onExpand={
              //     (expanded, record, index) => {
              //       //   expandRows=[0,1]
              //       this.rowchange(expanded, record)
              //     }

              //   }
              // // expandedRowKeys={[0,1]}
              // //  rowKey={
              // //   (record)=>{
              // //     this.oneRowchange(record)
              // //   }
              // // }
              // >
              //   <TreeNode icon={<Icon type="smile-o" />} title="parent 1" ></TreeNode>
              // </Tableant>
              :
              (this.state.loading ? <img className='loader' src={loader} /> : <span>No Data</span>)
              // <img className='loader' src={loader}/>
            }
            {/* <Tableant columns={antcolumns} dataSource={this.state.treeDataLayer}></Tableant> */}
          </div>
        </div>

        <br />

        <div className='container-fluid'>
          <div className='row'>

            {this.state.getWorkorder ? this.state.getWorkorder.hierarchy.map((ele, index) => {
              return (
                <div className='col-md-6 colmod6'>
                  <div className="card">


                  {this.state.clickeddownloadData[ele] ?
              <div className='agentsummery-downloadoptions'>
                <div class="list-group">
                {/* <CSVLink 
                data={this.state.alldownloadableData}
                 headers={this.state.ulbHeader}
                 >
                  <a  class="list-group-item list-group-item-action" onClick={this.toggleUlbDownloadOptions}>Export all data as csv</a>
                  </CSVLink>
                 <CSVLink data={this.state.agencyDataObject} headers={this.state.ulbHeader}>
                  <a  class="list-group-item list-group-item-action" onClick={this.toggleUlbDownloadOptions}>Export visible data as csv</a>
                  </CSVLink> */}
                  <CSVLink 
                data={this.state.alldownloadableData ? this.state.alldownloadableData[ele] : ""}  
                headers={this.state.ulbHeader}
                filename='dashboard_zipprs.csv'
                 >
            <a  class="list-group-item list-group-item-action" id={ele} onClick={this.toggleExpandDownload.bind(this)} disabled={this.state.alldownloadableData[ele] ? !this.state.alldownloadableData[ele].length : true}>Export all data as csv</a>
                  </CSVLink>
                  <CSVLink data={this.state.originalUlbTableDataObject[ele]} headers={this.state.ulbHeader}  filename='dashboard_zipprs.csv'>
                  <a  class="list-group-item list-group-item-action" id={ele} onClick={this.toggleExpandDownload.bind(this)}>Export visible data as csv</a>
                  </CSVLink>
                 
                </div>
              </div>
              :
              ""
              }

                    <div className='col-md-12' id='heading-district'>{this.state.getWorkorder.hierarchy[this.state.getWorkorder.hierarchy.length - 1] == ele ? "locality" : ele} REPORT</div>
                    <br />
                    <div className='row' id='select-row'>
                      <div className='col-md-3 firsr-select' >
                        <select class="form-control" name='agencyFilter' id={ele} onChange={this.tableAreaFilter.bind(this)}>
                          <option value="all">All Agencies</option>
                          {this.state.WorkOrderClients ? this.state.WorkOrderClients.map((client) => {
                            return <option value={client.id}>{client.name}</option>
                          })
                            : ""}
                          {/* <option>All Agencies</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option> */}
                        </select>
                      </div>
                      {index == 0 ? "" : <div className='col-md-3'>
                        <select class="form-control" id={ele} onChange={this.tableAreaFilter.bind(this)}>
                          {this.state.originalUlbTableDataObject[ele] ?
                            // <option value='all'>All {this.state.ulbTableDataObject[ele][0] ? this.state.ulbTableDataObject[ele][0].prevlayerKey : ""}s</option>
                          // <option value='all'>All {this.state.getWorkorder.hierarchy[index-1] ? _.capitalize(this.state.getWorkorder.hierarchy[index-1]) : ""}'s</option>
                           <option value='all'>All {this.state.getWorkorder.hierarchy[index-1] ? _.capitalize(pluralize(this.state.getWorkorder.hierarchy[index-1])) : ""}</option>

                            :  ""}


                          {this.state.parentObj[ele] ? (
                            this.state.parentObj[ele].map((prev) => {
                              return <option name="venu" value={JSON.stringify(prev)}>{prev.name}</option>
                            })
                          ) : ""
                          }



                          {/* <option>>{this.state.ulbTableDataObject[ele]}</option>
                           <option>2</option>
                          <option>3</option>
                          <option>4</option> */}
                        </select>
                      </div>}
                      <div className='col-md-3'>
                        <select class="form-control" name='timeFilter' id={ele} onChange={this.tableAreaFilter.bind(this)}>
                          <option value='lifetime'>Life Time</option>
                          <option value='today'>Today</option>
                          <option value='yesterday'>Yesterday</option>
                          <option value='last_7'>Last 7Days</option>
                          <option value='last_14'>last 14Days</option>
                          <option value='this_month'>This Month</option>
                          <option value='last_month'>Last Month</option>
                          <option value='this_year'>This Year</option>

                        </select>
                      </div>

                        {index == 0 ? <div className='col-md-3'></div> :  ""}

                      <div className='col-md-3 last-part'>

                      <button className='download-button' id={ele} onClick={this.downloadUlbData}>
                      <svg className="bi bi-arrow-down-short" id={ele} width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path id={ele} fill-rule="evenodd" d="M4.646 7.646a.5.5 0 01.708 0L8 10.293l2.646-2.647a.5.5 0 01.708.708l-3 3a.5.5 0 01-.708 0l-3-3a.5.5 0 010-.708z" clip-rule="evenodd" />
                        <path id={ele} fill-rule="evenodd" d="M8 4.5a.5.5 0 01.5.5v5a.5.5 0 01-1 0V5a.5.5 0 01.5-.5z" clip-rule="evenodd" />
                      </svg>
                    </button>

                      </div>
                    </div>

                    <Grid
                      rows={this.state.originalUlbTableDataObject[ele] ? this.state.originalUlbTableDataObject[ele] : firstLayerUlbArray}
                      columns={columns2}
                    >

                      <FilteringState defaultFilters={[]} />
                      <IntegratedFiltering />


                      <SortingState
                        defaultSorting={[{ columnName: 'city', direction: 'asc' }]}
                      />
                      <IntegratedSorting />

                      {/* <SearchState defaultValue="" />
        <IntegratedFiltering
          columnExtensions={filteringColumnExtensions}
        /> */}
                      <VirtualTable
                        height="17em"
                      />
                      <TableHeaderRow showSortingControls />
                      <TableFilterRow />
                      <TableColumnVisibility
                        defaultHiddenColumnNames={defaultHiddenColumnNames}
                        onHiddenColumnNamesChange={onHiddenColumnNamesChange}
                      />
                      <Toolbar />
                      {/* <SearchPanel /> */}
                      <ColumnChooser />

                    </Grid>

                  </div>
                </div>
              )
            }) : ""}

          </div>
        </div>


        <br />

      </div>


    )
  }
}



function mapStateToProps(state) {
  // ulbState: state
}

export default connect(
  mapStateToProps,
)(Ulb)
